
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ModelGallery from './components/ModelGallery';
import ModelDetails from './components/ModelDetails';
import ProcessTimeline from './components/ProcessTimeline';
import QRCodeSection from './components/QRCodeSection';
import RelatedModels from './components/RelatedModels';

export default function ModelPage() {
  const { id } = useParams();
  const [selectedModel, setSelectedModel] = useState<any>(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedImage, setSelectedImage] = useState(0);

  const models = {
    1: {
      id: 1,
      name: 'Championship Trophy Deluxe',
      category: 'Recognition Stoodio',
      price: 89.99,
      originalPrice: 99.99,
      rating: 4.9,
      reviews: 89,
      inStock: true,
      stockCount: 8,
      description: 'This magnificent championship trophy represents the pinnacle of 3D printing excellence. Featuring a detailed globe design with intricate circular base elements, this award-quality piece showcases superior craftsmanship and attention to detail. Perfect for competitions, corporate awards, or as a stunning display piece.',
      specifications: {
        material: 'Premium PLA Plastic',
        printTime: '15 hours 30 minutes',
        layerHeight: '0.2mm',
        dimensions: '180mm x 120mm x 120mm',
        weight: '245g',
        complexity: 'Advanced',
        supportStructures: 'Tree supports for overhangs',
        postProcessing: 'Sanded smooth, polished finish'
      },
      features: [
        'Award-quality finish',
        'Detailed globe design',
        'Stable circular base',
        'Professional appearance',
        'Customizable engraving area',
        'Durable construction'
      ],
      marketplaceLinks: {
        etsy: 'https://www.etsy.com/listing/championship-trophy-deluxe',
        makerworld: 'https://makerworld.com/models/championship-trophy-deluxe',
        printables: 'https://www.printables.com/model/championship-trophy-deluxe'
      },
      images: [
        'https://static.readdy.ai/image/95ea3a6b9baab5551419459f4fb45aca/e021f4311b50c904b4d4f02a3f51fd49.png',
        'https://static.readdy.ai/image/95ea3a6b9baab5551419459f4fb45aca/b9ce2e0d2092bcb6331e26e1a7b286ba.png',
        'https://public.readdy.ai/ai/img_res/9fe8d147f5230466323f979deb9afd2e.jpg',
        'https://readdy.ai/api/search-image?query=Bottom%20view%20of%203D%20printed%20trophy%20showing%20circular%20base%20design%20and%20structural%20details%2C%20high%20quality%20PLA%20print%20with%20fine%20details%2C%20professional%20product%20photography&width=800&height=800&seq=trophy-base-view&orientation=squarish'
      ]
    },
    2: {
      id: 2,
      name: 'Receptacles',
      category: 'SmartMount Stoodio',
      price: 45.00,
      originalPrice: 52.00,
      rating: 4.7,
      reviews: 156,
      inStock: true,
      stockCount: 12,
      description: 'A precision-crafted architectural model showcasing modern design principles with clean lines and detailed features.',
      specifications: {
        material: 'High-Quality PLA',
        printTime: '12 hours',
        layerHeight: '0.15mm',
        dimensions: '150mm x 100mm x 80mm',
        weight: '180g',
        complexity: 'Intermediate',
        supportStructures: 'Minimal supports',
        postProcessing: 'Clean finish, detail enhancement'
      },
      features: [
        'Architectural accuracy',
        'Detailed windows and doors',
        'Clean modern design',
        'Educational value',
        'Display ready',
        'Scale model precision'
      ],
      marketplaceLinks: {
        etsy: 'https://www.etsy.com/listing/modern-house-receptacles',
        makerworld: 'https://makerworld.com/models/architectural-receptacles',
        printables: 'https://www.printables.com/model/house-receptacles-model'
      },
      images: [
        'https://static.readdy.ai/image/95ea3a6b9baab5551419459f4fb45aca/43e91f80634d456c39adaec30a11d62c.png',
        'https://readdy.ai/api/search-image?query=Close-up%20of%203D%20printed%20house%20model%20showing%20window%20and%20door%20details%2C%20architectural%20precision%20in%20white%20PLA%20material%2C%20professional%20product%20photography&width=800&height=800&seq=house-detail&orientation=squarish',
        'https://readdy.ai/api/search-image?query=Side%20view%20of%203D%20printed%20modern%20house%20model%20showing%20architectural%20proportions%2C%20clean%20design%20with%20professional%20lighting%20on%20white%20background&width=800&height=800&seq=house-side&orientation=squarish',
        'https://readdy.ai/api/search-image?query=Top%20view%20of%203D%20printed%20house%20model%20showing%20roof%20structure%20and%20layout%2C%20architectural%20model%20with%20fine%20details%20in%20white%20PLA&width=800&height=800&seq=house-top&orientation=squarish'
      ]
    },
    3: {
      id: 3,
      name: 'Soccer Ball',
      category: 'Lifestyle Stoodio',
      price: 24.99,
      originalPrice: 29.99,
      rating: 4.6,
      reviews: 203,
      inStock: true,
      stockCount: 15,
      description: 'A meticulously designed 3D printed soccer ball featuring authentic hexagonal and pentagonal panel patterns. Perfect for display, educational purposes, or as a unique gift for soccer enthusiasts.',
      specifications: {
        material: 'Durable PLA',
        printTime: '8 hours',
        layerHeight: '0.2mm',
        dimensions: '220mm diameter',
        weight: '150g',
        complexity: 'Intermediate',
        supportStructures: 'None required',
        postProcessing: 'Smooth finish'
      },
      features: [
        'Authentic soccer ball pattern',
        'Lightweight design',
        'No supports needed',
        'Educational geometry',
        'Display quality',
        'Durable construction'
      ],
      marketplaceLinks: {
        etsy: 'https://www.etsy.com/listing/3d-printed-soccer-ball',
        makerworld: 'https://makerworld.com/models/geometric-soccer-ball',
        printables: 'https://www.printables.com/model/soccer-ball-geometric'
      },
      images: [
        'https://readdy.ai/api/search-image?query=3D%20printed%20soccer%20ball%20with%20detailed%20hexagonal%20pattern%2C%20white%20and%20black%20PLA%20material%2C%20realistic%20football%20design%20with%20precise%20geometric%20panels%2C%20professional%20product%20photography%20on%20white%20background&width=800&height=800&seq=soccer-ball&orientation=squarish'
      ]
    },
    4: {
      id: 4,
      name: 'Garden Planter',
      category: 'Greenscape Stoodio',
      price: 32.50,
      originalPrice: 38.00,
      rating: 4.8,
      reviews: 127,
      inStock: true,
      stockCount: 9,
      description: 'An elegant decorative garden planter featuring modern geometric patterns and functional drainage system. Perfect for herbs, succulents, or small flowering plants.',
      specifications: {
        material: 'Weather-resistant PLA',
        printTime: '10 hours',
        layerHeight: '0.25mm',
        dimensions: '160mm x 160mm x 120mm',
        weight: '200g',
        complexity: 'Beginner',
        supportStructures: 'None required',
        postProcessing: 'Drainage holes added'
      },
      features: [
        'Drainage system included',
        'Weather-resistant material',
        'Modern geometric design',
        'Perfect for small plants',
        'Easy to print',
        'Indoor/outdoor use'
      ],
      marketplaceLinks: {
        etsy: 'https://www.etsy.com/listing/geometric-garden-planter',
        makerworld: 'https://makerworld.com/models/modern-planter-pot',
        printables: 'https://www.printables.com/model/decorative-garden-planter'
      },
      images: [
        'https://readdy.ai/api/search-image?query=3D%20printed%20decorative%20garden%20planter%20with%20geometric%20pattern%2C%20white%20PLA%20material%2C%20modern%20home%20decor%20design%20with%20drainage%20holes%2C%20clean%20product%20photography%20on%20white%20background&width=800&height=800&seq=garden-planter&orientation=squarish'
      ]
    },
    5: {
      id: 5,
      name: 'Robot Action Figure',
      category: 'ModelMaster Stoodio',
      price: 42.00,
      originalPrice: 48.00,
      rating: 4.9,
      reviews: 89,
      inStock: true,
      stockCount: 6,
      description: 'A highly detailed robot action figure with articulated joints and futuristic design elements. Features moveable arms, legs, and head for dynamic posing and display.',
      specifications: {
        material: 'High-detail PLA',
        printTime: '14 hours',
        layerHeight: '0.15mm',
        dimensions: '200mm x 80mm x 60mm',
        weight: '180g',
        complexity: 'Advanced',
        supportStructures: 'Tree supports for joints',
        postProcessing: 'Joint assembly, detail painting'
      },
      features: [
        'Fully articulated joints',
        'Futuristic design',
        'High detail level',
        'Poseable figure',
        'Collector quality',
        'Assembly required'
      ],
      marketplaceLinks: {
        etsy: 'https://www.etsy.com/listing/articulated-robot-figure',
        makerworld: 'https://makerworld.com/models/poseable-robot-action-figure',
        printables: 'https://www.printables.com/model/robot-action-figure-articulated'
      },
      images: [
        'https://readdy.ai/api/search-image?query=3D%20printed%20robot%20action%20figure%20with%20articulated%20joints%2C%20futuristic%20design%20in%20silver%20PLA%20material%2C%20detailed%20mechanical%20features%2C%20toy%20photography%20on%20white%20background%20with%20dramatic%20lighting&width=800&height=800&seq=robot-figure&orientation=squarish'
      ]
    },
    6: {
      id: 6,
      name: 'Fidget Spinner',
      category: 'Lifestyle Stoodio',
      price: 18.99,
      originalPrice: 22.99,
      rating: 4.5,
      reviews: 312,
      inStock: true,
      stockCount: 20,
      description: 'A smooth-spinning fidget toy designed for stress relief and focus enhancement. Features precision-balanced design with integrated bearing system for optimal spin performance.',
      specifications: {
        material: 'Smooth PLA',
        printTime: '4 hours',
        layerHeight: '0.2mm',
        dimensions: '75mm diameter x 8mm thick',
        weight: '45g',
        complexity: 'Beginner',
        supportStructures: 'None required',
        postProcessing: 'Bearing installation'
      },
      features: [
        'Smooth spinning action',
        'Stress relief design',
        'Balanced weight distribution',
        'Easy to print',
        'Portable size',
        'Durable construction'
      ],
      marketplaceLinks: {
        etsy: 'https://www.etsy.com/listing/3d-printed-fidget-spinner',
        makerworld: 'https://makerworld.com/models/precision-fidget-spinner',
        printables: 'https://www.printables.com/model/smooth-fidget-spinner'
      },
      images: [
        'https://readdy.ai/api/search-image?query=3D%20printed%20fidget%20spinner%20with%20smooth%20bearings%2C%20colorful%20PLA%20material%20design%2C%20functional%20stress%20relief%20toy%20with%20balanced%20weight%20distribution%2C%20product%20photography%20on%20white%20background&width=800&height=800&seq=fidget-spinner&orientation=squarish'
      ]
    }
  };

  useEffect(() => {
    const modelId = parseInt(id || '1');
    setSelectedModel(models[modelId as keyof typeof models] || models[1]);
  }, [id]);

  if (!selectedModel) {
    return <div>Loading...</div>;
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Breadcrumb */}
      <div className="bg-gray-50 py-4">
        <div className="container mx-auto px-6">
          <nav className="flex items-center space-x-2 text-sm text-gray-600">
            <a href="/" className="hover:text-blue-600 cursor-pointer">Home</a>
            <i className="ri-arrow-right-s-line"></i>
            <a href="/models" className="hover:text-blue-600 cursor-pointer">Models</a>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900">{selectedModel.name}</span>
          </nav>
        </div>
      </div>

      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          {/* Model Gallery */}
          <ModelGallery 
            images={selectedModel.images}
            selectedImage={selectedImage}
            onImageSelect={setSelectedImage}
            modelName={selectedModel.name}
          />

          {/* Model Details */}
          <ModelDetails 
            model={selectedModel}
            quantity={quantity}
            onQuantityChange={setQuantity}
          />
        </div>

        {/* Process Timeline */}
        <ProcessTimeline modelId={selectedModel.id} />

        {/* QR Code Section */}
        <QRCodeSection modelId={selectedModel.id} modelName={selectedModel.name} />

        {/* Related Models */}
        <RelatedModels currentModelId={selectedModel.id} category={selectedModel.category} />
      </div>
    </div>
  );
}
